import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-share-link-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './share-link-dialog.html',
  styleUrl: './share-link-dialog.scss'
})
export class ShareLinkDialog {
  readonly dialogRef = inject(MatDialogRef<ShareLinkDialog>);
  readonly data = inject<{ url: string }>(MAT_DIALOG_DATA);
  private snackBar = inject(MatSnackBar);
  private clipboard = inject(Clipboard);

  copyLink(): void {
    this.clipboard.copy(this.data.url);
    this.snackBar.open('Link copied to clipboard', 'Close', { duration: 3000 });
  }

  openLink(): void {
    window.open(this.data.url, '_blank');
  }
}
